import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';

export function CTA() {
  return (
    <section id="contato" className="py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6">
        <div className="relative overflow-hidden rounded-2xl bg-card border border-border px-8 py-16 text-center sm:px-16">
          {/* Subtle grid overlay */}
          <div
            className="pointer-events-none absolute inset-0 opacity-[0.03]"
            style={{
              backgroundImage:
                'linear-gradient(hsl(215 60% 22%) 1px, transparent 1px), linear-gradient(90deg, hsl(215 60% 22%) 1px, transparent 1px)',
              backgroundSize: '40px 40px',
            }}
          />

          <div className="relative">
            <h2 className="font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl text-balance">
              Seu negócio está no limiar da mudança.
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
              Conte pra gente o que você precisa. Vamos entender o seu cenário e
              mostrar como a tecnologia pode transformar seus resultados.
            </p>
            <div className="mt-8">
              <Button
                size="lg"
                asChild
                className="bg-accent text-accent-foreground hover:bg-accent/90"
              >
                <a
                  href="https://wa.me/5581997550684"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Vamos conversar
                  <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
